module.exports = __webpack_public_path__ + "static/media/cq_indietro b.713fbdd7.svg";